import { Box, ButtonNew, ColorOptions, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'

export const TalkToUs = () => {
  const viewPortWidth = useWindowDimensions()
  const isMob = isMobileWidth(viewPortWidth)
  const { headerSize, textSize } = useFontSize()
  const { navigate } = useNavigation()
  const resPadding = usePadding()
  return (
    <Box
      borderTopRightRadius={isMob ? 32 : 100}
      borderTopLeftRadius={isMob ? 32 : 100}
      bg={'#24397A0A' as ColorOptions}
      pt={isMob ? 120 : 160}
      pb={isMob ? 160 : 240}
      ph={isMob ? 1.5 * resPadding : '25%'}
      align={'center'}>
      <Text
        title={staticStrings.talkToUsTitle}
        fontFamily={'jiotype-black'}
        color={'BLACK_21'}
        fontSize={headerSize}
        textAlign={'center'}
        lineHeight={isMob ? 32 : 72}
      />
      <Spacer size={isMob ? 16 : 32} />
      <Text
        title={staticStrings.talktoUsPara}
        fontFamily={'jiotype-medium'}
        color={'BLACK_21'}
        fontSize={textSize}
        opacity={0.9}
        lineHeight={isMob ? 20 : 28}
        textAlign={'center'}
      />
      <Spacer size={isMob ? 32 : 54} />
      <ButtonNew
        borderRadius={8}
        width={isMob ? 144 : 192}
        height={isMob ? 48 : 56}
        color={colors.HIGHLIGHT as ColorOptions}
        onPress={() => navigate('contact')}
        hoverColor={colors.HIGHLIGHT as ColorOptions}>
        <Text title={staticStrings.talkto} fontFamily={'jiotype-bold'} color={'WHITE'} fontSize={14} />
      </ButtonNew>
    </Box>
  )
}
